module.exports = __webpack_public_path__ + "static/assets/fc4228c3fe329628c4ba78569e5620eb.gif";